import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  /**
   * Stores data in localStorage as JSON.
   * @param storageKey - The key to store data under
   * @param data - The data to store (will be JSON serialized)
   * @returns true if successful, false if storage failed (e.g., quota exceeded)
   */
  public setData(storageKey: string, data: unknown): boolean {
    try {
      localStorage.setItem(storageKey, JSON.stringify(data));
      return true;
    } catch {
      return false;
    }
  }

  /**
   * Retrieves and parses JSON data from localStorage.
   * @param storageKey - The key to retrieve data from
   * @returns The parsed data, or null if not found or corrupted
   */
  public getData<T>(storageKey: string): T | null {
    const data = localStorage.getItem(storageKey);

    if (!data) {
      return null;
    }

    try {
      return JSON.parse(data) as T;
    } catch {
      // Data is corrupted, remove it
      this.removeData(storageKey);
      return null;
    }
  }

  /**
   * Removes a specific key from localStorage.
   * @param storageKey - The key to remove
   */
  public removeData(storageKey: string): void {
    localStorage.removeItem(storageKey);
  }

  /**
   * Clears all data from localStorage.
   */
  public removeAllData(): void {
    localStorage.clear();
  }
}
